<template lang="pug">
  div
    .main
      .row
        .col-md-6.col-lg-5.col-xl-4
          h2.title 数据总览-漏控系统
</template>

<script>
export default {
  name: 'dashboard-businessCharges'
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// LeakageControl.vue?ca382d92